import { connect } from "react-redux";
import {
  getLanDongLaiChoVay,
  postTatToanChoVay,
  postTatToanChoDuyetChoVay,
  getTatToanChoVay,
  postThayDoiKyThanhToanChoVay,
} from "actions/QuanLyChoVay";
import ThayDoiKyLaiTraGop from "components/CommonComponent/ThayDoiKyLaiTraGop";

const mapStateToProps = (state) => ({
  camdo: state.camdo,
  quanlychovay: state.quanlychovay,
  quanlythuchi: state.quanlythuchi,
  user: state.user,
  cauhinh: state.cauhinh,
  themmoicamdo: state.themmoicamdo,
  phanquyen: state.phanquyen,
  loaitaisan: state.loaitaisan,
  inthuchi: state.inthuchi,
});

const mapDispatchToProps = (dispatch) => ({
  getLanDongLaiChoVay: (dataSearch) =>
    dispatch(getLanDongLaiChoVay(dataSearch)),
  postTatToanChoVay: (dataPost) => dispatch(postTatToanChoVay(dataPost)),
  postThayDoiKyThanhToanChoVay: (dataPost) => dispatch(postThayDoiKyThanhToanChoVay(dataPost)),
  postTatToanChoDuyetChoVay: (dataPost) => dispatch(postTatToanChoDuyetChoVay(dataPost)),
  getTatToanChoVay: (dataPost) => dispatch(getTatToanChoVay(dataPost)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ThayDoiKyLaiTraGop);
